import * as tslib_1 from "tslib";
import Paper from 'sinoui-components/Paper';
var EditableSelectPopLayout = Paper.extend(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export default EditableSelectPopLayout;
var templateObject_1;
//# sourceMappingURL=EditableSelectPopLayout.js.map